import { SequentialCallbackTask } from 'app/model/adfDataMapper/taskExecutor/schemaImportCallbackTask';
import { CancellationToken } from 'app/model/adfDataMapper/taskExecutor/cancellationToken';

export class SequentialTask {
    public readonly callback: SequentialCallbackTask;
    private readonly _cancellationToken: CancellationToken;
    private _func: () => void | Promise<void>;

    constructor() {
        this.callback = new SequentialCallbackTask();
        this._cancellationToken = new CancellationToken();
    }

    public get cancellationToken(): CancellationToken {
        return this._cancellationToken;
    }

    public get func(): () => void | Promise<void> {
        return this._func;
    }

    public set func(funcToExecute: () => void | Promise<void>) {
        this._resetCancellationToken();
        this._func = funcToExecute;
    }

    private _resetCancellationToken(): void {
        this._cancellationToken.reset();
    }
}
